import { Theme } from '@mui/material/styles';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      '& mjx-container': {
        '&:focus': {
          outline: 'none',
        },
        '& svg': {
          maxWidth: '100%',
        },
      },
      '& mjx-container[jax="SVG"][display="true"]': {
        background: theme.palette.secondary.light,
        paddingTop: 18,
        paddingBottom: 18,
        marginTop: 18,
        marginBottom: 18,
        borderRadius: 5,
      },
    },
  }),
);

export default useStyles;
